import moment from 'moment-mini'
import DateView from '../views/DateView'
import pickerDateMixin from './picker-date-mixin'
import { PickerType } from '../constants'
import _ from 'lodash'
import DefaultButton from '../../default-button'
import Button from '../../button'

export default {
  name: 'KDatePickerDate',
  mixins: [pickerDateMixin],
  provide() {
    return {
      picker: this,
    }
  },
  props: {
    // 面板数量，只有在multiple为true时生效
    paneCount: {
      type: Number,
      default: 2,
    },
  },
  data() {
    return {
      pickerType: PickerType.Date,
      referenceValue: moment(),
      selectedDate: [],
      referenceList: [],
    }
  },
  computed: {
    year() {
      return this.referenceValue && this.referenceValue.year()
    },
    month() {
      return this.referenceValue && this.referenceValue.month()
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(value) {
        if (this.multiple) {
          this.referenceValue = (_.isArray(value) && value[0]) || this.defaultReferenceValue || moment()
          this.selectedDate = _.clone(value)
        } else {
          this.referenceValue = value || this.defaultReferenceValue || moment()
        }
      },
    },
    active: {
      immediate: true,
      handler(value) {
        if (value) {
          this.selectedDate = this.multiple ? _.clone(this.value) : this.value
          if (this.multiple) {
            this.referenceValue = (_.isArray(this.value) && this.value[0]) || this.defaultReferenceValue || moment()
          } else {
            this.referenceValue = this.value || this.defaultReferenceValue || moment()
          }
          this.generateReferenceList()
        }
      },
    },
    referenceValue() {
      if (this.active) {
        this.generateReferenceList()
      }
    },
  },
  created() {
    this.$on('click-prev', (referenceValueKey) => {
      this[referenceValueKey] = this[referenceValueKey].clone().subtract(1, 'month')
    })

    this.$on('click-next', (referenceValueKey) => {
      this[referenceValueKey] = this[referenceValueKey].clone().add(1, 'month')
    })
  },
  methods: {
    generateReferenceList() {
      const { referenceValue, paneCount } = this
      if (this.multiple) {
        const list = []
        for (let i = 0; i < paneCount; i++) {
          list.push({
            references: referenceValue.clone().add(i, 'month'),
            renderPrev: i === 0,
            renderNext: i === paneCount - 1,
          })
        }
        this.referenceList = list
      } else {
        this.referenceList = [{
          references: referenceValue,
          renderPrev: true,
          renderNext: true,
        }]
      }
    },
    handleCellClick(cell) {
      if (this.multiple) {
        const selectedDate = _.clone(this.selectedDate)
        const removeList = _.remove(selectedDate, item => item.isSame(cell.value, 'day'))
        if (removeList.length === 0) {
          selectedDate.push(cell.value)
        }
        this.selectedDate = selectedDate
      } else {
        this.$emit('pick', cell.value)
      }
    },
    confirm() {
      this.$emit('confirm', this.selectedDate)
    },
    cancel() {
      this.$emit('cancel')
    },
    clear() {
      this.selectedDate = []
    },
    renderFooter() {
      if (!this.multiple) {
        return
      }
      const count = this.selectedDate.length
      return (
        <div class="km-date-picker__pane-footer">
          {
            this.$scopedSlots.footer
              ? this.$scopedSlots.footer({ confirm: this.confirm.bind(this), cancel: this.cancel.bind(this), clear: this.clear.bind(this) })
              : <div class="km-pane-footer">
                  {
                    this.$scopedSlots.footerExtra
                      ? this.$scopedSlots.footerExtra({ count })
                      : (count > 0 ? <div class="km-pane-footer__count">已选{count}天</div> : '')
                  }

                  <div class="km-pane-footer__operation">
                    <DefaultButton
                      size="mini"
                      onClick={this.cancel}
                    >
                      取消
                    </DefaultButton>

                    <Button
                      type="primary"
                      size="mini"
                      onClick={this.confirm}
                    >
                      确定
                    </Button>
                  </div>
                </div>
          }
        </div>
      )
    },
    getDatePane({ references = moment(), renderPrev = true, renderNext = true } = {}) {
      return (
        <div class="km-date-picker__pane">
          {this.renderHeader(references, { renderPrev, renderNext })}
          <DateView
            referenceValue={references}
          >
            {this.$scopedSlots.default}
          </DateView>
        </div>
      )
    },
  },
  render() {
    const { multiple, referenceList } = this
    const data = {
      class: {
        'km-date-picker__pane-wrapper': true,
        'km-date-multiple-picker__pane-wrapper': multiple,
      },
    }

    return (
      <div {...data}>
        {this.renderShortcuts()}
        <div class="km-date-picker__pane-container">
          <div class="km-date-picker__pane-list">
            { _.map(referenceList, item => this.getDatePane(item)) }
          </div>

          {this.renderFooter()}
        </div>
      </div>
    )
  },
}
